import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import { LISTING_STATE_DRAFT } from '../../util/types';
import { ensureListing } from '../../util/data';
import { EditListingSpecialInfoForm } from '../../forms';
import { ListingLink } from '../../components';

import css from './EditListingSpecialInfoPanel.module.css';

const SPECIALINFO_NAME = 'specialInfo';

const EditListingSpecialInfoPanel = props => {
  const {
    rootClassName,
    className,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureListing(listing);
  const { publicData } = currentListing.attributes;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = (
                  <h2>
                  Votre parking possède un petit plus que vous souhaitez mettre en avant (votre place possède une borne de recharge, parking proche d’un métro ou d’un monument…) C’est le moment d’en parler ! Si vous êtes ouverts à la vente de votre parking, c’est aussi le moment d’en parler car nos utilisateurs sont également intéressés par l’achat de parking et cela peut être une opportunité pour vous !
                  </h2>
                  );


  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      <EditListingSpecialInfoForm
        className={css.form}
        name={SPECIALINFO_NAME}
        // initialValues={{ accessReset: publicData.accessReset, accessPeriod: publicData.accessPeriod }} bookingType
        initialValues={{ specialInfo: publicData.specialInfo,
         }} 
        onSubmit={values => {
          const { specialInfo} = values;

          const updatedValues = {
            publicData: { specialInfo
            },
          };
          onSubmit(updatedValues);
        }}
        onChange={onChange}
        saveActionMsg={submitButtonText}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
        currentListing={currentListing}
      />
    </div>
  );
};

EditListingSpecialInfoPanel.defaultProps = {
  rootClassName: null,
  className: null,
  listing: null,
};

const { bool, func, object, string } = PropTypes;

EditListingSpecialInfoPanel.propTypes = {
  rootClassName: string,
  className: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingSpecialInfoPanel;
